import {ComponentType} from "@angular/cdk/overlay";
import {FilterTranslator} from "./ngx-types";

export class NgxFilterConfig {
  dateComponent?: ComponentType<any>;
  numberBoxComponent?: ComponentType<any>;
  textBoxComponent?: ComponentType<any>;
  selectBoxComponent?: ComponentType<any>;
  multiSelectBoxComponent?: ComponentType<any>;
  trueFalseComponent?: ComponentType<any>;
  conditionSelectorComponent?: ComponentType<any>;
  // translator:
  translator?: FilterTranslator;

}
